window.__languageBundle__ = {
    "language": "en",
    "emailInvoice": "Email Invoice",
    "downloadInvoice": "Download Invoice",
    "downloadInvoiceInit": "Preparing your invoice…",
    "downloadInvoiceSuccess": "Download started. Please check notifications.",
    "downloadCompleted": "Download completed.",
    "downloadInvoiceApiErr": "Oops! Something went wrong. The invoice will be sent to your registered email ID",
    "downloadInvoiceNetErr": "Check your network connection!",
    "trackIssue": "Track Issue",
    "viewAll" :"View all",
    "supermartBasketLength": "Kilos Basket ({length} item{pluralString})",
    "groupBuySupermartBasketLength": "Kilos ({length} item{pluralString})",
    "hyperlocalBasketLength": "Minutes Basket ({length} item)",
    "xtrasaverBasketLength": "Xtrasaver Basket ({length} item)",
    "shareOrderMsg": "{buyer} shared this order with you.",
    "bnplInProgressTitle": "Your order's approval is in progress.",
    "bnplInProgressText": "Your order status will be updated in 15 - 30 minutes",
    "bnplOnHoldTitle": "Flipkart Pay Later outstanding of ₹{billAmount} is not paid.",
    "bnplOnHoldText": "If amount is not paid in 24 hours, some orders will be cancelled",
    "errorMsg": "Oops! Something went wrong. Please try again later.",
    "errorMsg1" : "Something went wrong. Please try again later.",
    "errorMsg3" : "Oops! Some error occured.",
    "errorMsg4" : "A maximum of Rs 250 will be refunded towards the shipping cost if the delivery partner's bill is shared. Please check the return request related email for detailed instructions.",
    "errorMsg5" : "Try these steps, observe your phone for 1-2 days. If the problem still persists, visit My Orders page.",
    "errorMsg6" : "Could not update bank details. Please try again",
    "errorMsg7" : "Please enter the following details to create refund request.",
    "errorMsg8" : "We are unable to dig up your order details right now. Things should return to normal in a few minutes. Your detailed order history is safe with us, of course!",
    "errorMsg9" : "Something went wrong! Please try again later",
    "errorMsg10": "Something Went Wrong! Please visit in sometime",
    "cancel": "Cancel",
    "select": "Select",
    "back": "BACK",
    "next": "NEXT",
    "getCode": "GET CODE",
    "lockinRewardTitle": "Your rewards on this order",
    "lockinMoreRewards": "More rewards",
    "enterOTP": "Enter OTP",
    "refundNEFT": "Bank Transfers (IMPS)", //TODO - check this
    "refundIMPS": "Bank Transfers (IMPS)",
    "refunds": "refunds.",
    "refundGiftCard": "Flipkart E Gift Cards",
    "selectAccount": "Select Account",
    "egvTnCl1": "Use within 12 months for future purchases.",
    "egvTnCl2": "Can not be redeemed for cash or credit.",
    "tncLine1": "By clicking on {text} ",
    "tncLine2": "I agree to",
    "tncLine3": " terms and conditions",
    "tncLine4": " of {refundText}",
    "submitRequest": "Submit Request",
    "selectOption": "Select an option",
    "english" : "English",
    "hindi" : "Hindi",
    "french" : "French",
    "viewMore" : "View more",
    "viewLess" : "View Less",
    "loginMessage": "Login to get help with your recent orders",
    "loginContactUsMsg": "Login to contact us",
    "helpMessage": "You can easily manage your orders in My Orders section",
    "faqMessage": "Feel free to talk to us about any queries or feedback. Customer satisfaction is our highest priority.",
    "orderRelatedIssues" : "Issues related to an order",
    "issueNotResolved" : "Issue still not resolved?",
    "orderQueries": "Order Related Queries",
    "otherIssues" : "Other Issues",
    "goToMyOrder" : "Go to My Orders",
    "didYouKnow" : "Did you know?",
    "helpTopics": "Browse Help Topics",
    "contactUs" : "Contact Us",
    "addressMessage" : "Want to reach us the old style?",
    "postalAddress" : "postal address",
    "faqHeaderTitle" : "Frequently Asked Questions",
    "recentOrdersHelpTitle" : "NEED HELP WITH RECENT ORDERS?",
    "postalAddrssCapital" : "POSTAL ADDRESS",
    "corpAddressCapital" : "CORPORATE ADDRESS",
    "cin" : "CIN: {cinValue}",
    "anyOtherIssues" : "ANY OTHER ISSUES?",
    "howDoYouWishToContactUs" : "HOW DO YOU WISH TO CONTACT US?",
    "responseTime1Min" : "Response time : Within 1 minute",
    "responseTimeNMins" : "Response time : Within {n}",
    "estTime1Min" : "Est. time - Within 1 minute",
    "estTimeNMins" : "Est. time - Within {n}",
    "noAgentAvailable": "There's no agent available currently. Please try again after at least 30 mins.",
    "gotoOD": "Go back to Order Details",
    "timeSlot": "Select a time slot",
    "allSlots": "View All Slots",
    "callMeBack" : "Call me back",
    "emailUs" : "Email us",
    "callUsNow" : "Call us now",
    "chatWithUs" : "Chat with us",
    "requestACall" : "Request a call",
    "submit" : "SUBMIT",
    "lower_submit" : "Submit",
    "login" : "LOGIN",
    "tel" : "tel",
    "sendEmail" : "SEND EMAIL",
    "needHelp" : "Need help?",
    "addEMail" : "Add Email",
    "addEmailMessage" : "It seems you don’t have email associated with your Flipkart Account. Please add and verify the email with your account to reach us via email.",
    "feedback" : "Feedback",
    "reasonForFeedback" : "Reason for feedback",
    "tellUsFeedback" : "Tell us your feedback",
    "selectAnIssue" : "Please select an issue",
    "selectAnSubIssue" : "Please select a sub issue:",
    "relatedFAQs" : "Related FAQs:",
    "relatedQuestions" : "RELATED QUESTIONS",
    "browseHelp" : "Browse Help",
    "commonlySearchFAQs" : "COMMONLY SEARCHED FAQS",
    "selectCategory" : "SELECT CATEGORY",
    "ordersHelpV2": "Which item are you facing an issue with?",
    "ordersTrack": "Select an item to track, check order status or call the delivery agent",
    "ordersReturn": "Select an item to create or track returns & refunds",
    "ordersManage": "Select an item to change address, delivery date, and more",
    "nonOrderHeading": "Select an issue",
    "faqs" : "FAQs",
    "moreIssuesRelatedTo" : "More issues related to",
    "recentIssuesRaisedWithUs" : "RECENT ISSUES RAISED WITH US",
    "helpCentre" : "Help Centre",
    "sorryNoResultsFound" : "Sorry, no results found",
    "notMatchingQuery" : "We couldn't find anything that matches '{queryText}'",
    "helpWithOrder" : "Help with Order",
    "viewDetails" : "VIEW DETAILS",
    "ocViewDetails" : "View Details",
    "selectOrder" : "Select Order",
    "selectOrderError" : "Oops! Some error occurred. Please try again later.",
    "helpWithOtherIssues" : "Help with Other Issues",
    "helpWithOtherIssuesError" : "Oops! Something went wrong. Please try again later.",
    "preOrdered" : "Pre ordered",
    "deliveryByTomorrow" : "Delivery by tomorrow",
    "delayed" : "Delayed",
    "giftCard" : "Gift Card",
    "flipkartFirst" : "Flipkart First",
    "wallet" : "Wallet",
    "nDaysLeftToReach" : "{days} days left to reach you",
    "iAgreeToReceiveACall" : "I agree to receive a call by {date}",
    "agree2Schedule" : "I agree to receive a call {conj} {date}",
    "resolutionResolved" : "Resolved on {date}",
    "resolutionToBeResolved" : "To be resolved by {date}",
    "resolutionCreatedOn" : "Created on {date}",
    "error1" : "Oops, there was an error. Please try again later.",
    "addNewAdd" : "Add a new address",
    "changeAdd" : "Change address",
    "selectAddress" : "Select Address",
    "savedAddresses" : "Saved addresses",
    "changeAddMessage" : "Please note that all the items in the order would be delivered to the new address",
    "noSavedAdd" : "No other saved addresses",
    "deliverHere" : "DELIVER HERE",
    "rateAndReview" : "Rate and Review the product based on your experience {colon}",
    "more": "{prefix} more",
    "writeReview" : "Write a Review",
    "addAReview": "Add a Review",
    "writeReviewWinRewards" : "Win gift cards for photo reviews",
    "addReview" : "Add Review",
    "edit" : "EDIT",
    "viewTermAndConditions": "View terms and conditions",
    "openGoogleMap" : "Open in Google Maps",
    "pickUpParcelFromHub" : "You will have to pick up the parcel from the hub",
    "deliveryAddress": "Delivery Address",
    "billingAddress" : "Billing Address",
    "requestedAddress" : "Requested Address",
    "requestToChangeAddress" : "We are processing your request to change the address.",
    "change" : "Change",
    "dontChange": "Don't Change",
    "tentativeRelease" : "Tentative release",
    "deliveredOn" : "Delivered on",
    "deliveredTo" : "Delivered to {name}",
    "deliveryBy" : "Delivery by",
    "delivery" : "Delivery",
    "on": "on",
    "newDeiveryDate" : "{fromDeliveryDate} to {toDeliveryDate}",
    "deliveryDate" : "{fromDeliveryDate} to {toDeliveryDate}",
    "sender" : "Sender : {giftFrom}",
    "receiver" : "Receiver : {giftTo}",
    "giftMessage" : "Message : {giftMessageText}",
    "giftWrapCharge" : "Gift wrap charge: {amount}",
    "rupeesWithAmount" : "Rs. {amount}",
    "AFTERNOON": "Afternoon",
    "MORNING": "Morning",
    "EVENING": "Evening",
    "NIGHT": "Night",
    "LATE_NIGHT": "Late Night",
    "EARLY_MORNING": "Early Morning",
    "successExpectCallOneMin" : "Success. Please expect a call in the next 1 minute.",
    "successExpectCall" : "Success. Please expect a call in the next {waitTime} minutes.",
    "scheduleCall" : "You'll receive a call between {waitTime}.",
    "scheduleCallNow" : "You'll receive a call in {waitTime}.",
    "requestFailedTryAgain" : "Request failed. Please try again later.",
    "kannada": "Kannada",
    "noSlot":"No time slot is available",
    "inLang" : " in {lang}, please select other language",
    "someAvailableActions" : "Here are some available actions on your item",
    "contactWaysDisplayName" : "Order {orderID}",
    "allowedOnly2Files" : "Only two files are allowed",
    "allowedOnly8Files" : "Only 8 files allowed",
    "instruction8FilesUpload": "You can upload up to 8 files",
    "instruction3MBPerFileUpload": "Each file shouldn't exceed 3MB and total file size shouldn't exceed 10MB",
    "instruction5MBPerFileUpload": "Each file shouldn't exceed 5MB and total file size shouldn't exceed 10MB",
    "fileTooLarge": "Total file size shouldn't exceed 10 MB. Try again",
    "instruction10MBFilesUpload": "Total file size shouldn't exceed 10 MB",
    "imageFailedInstructions": "Some files could not be uploaded. Try Again",
    "maxMBAllowed" : "Maximum {size}MB is allowed",
    "onlyImgAllowed": "Only image is allowed",
    "onlyPDFImgAllowed" : "Only PDF/image is allowed",
    "enterValidEmailAdd" : "Please enter a valid email address.",
    "enterAMessageToSend" : "Please enter a message to send.",
    "thankYouFeedback" : "Thank you for your feedback.",
    "selectAtleastOneOption" : "Select atleast one option to continue",
    "heresOur" : "Here's our",
    "youCanReachDeliveryPerson" : "You can reach the delivery person at :",
    "youCanReachDeliveryPersonWithDetails" : "You can reach the delivery person at {feNumber} ",
    "extWithNum" : "Ext :{extNum}",
    "orderWillBeDelivered" : "Your order has been delivered to :",
    "quantity" : "Quantity",
    "price" : "PRICE",
    "paymentBy" : "Payment by",
    "updatesSentTo" : "Updates sent to",
    "suggestionsBasedOnOrder" : "Suggestions Based on Your Order",
    "referNow" : "REFER NOW",
    "refund" : "Refund",
    "cancelFeeRefund": "Cancellation Fee Refund",
    "refundTo" : "Refund to",
    "returnID" : "Return ID",
    "unSubscribedMsg" : "You have been unsubscribed.",
    "subscribedMsg" : "You have been subscribed.",
    "stopDelievryUpdate" : "Stop detailed delivery updates:",
    "getDelievryUpdate" : "Get detailed delivery updates",
    "pincodeNotServiceable" : "Sorry, this pincode isn't serviceable.",
    "addChangeSuccess" : "You have successfully placed a request for address change.",
    "home" : "Home",
    "work" : "Work",
    "pincode" : "Pincode",
    "name" : "Name",
    "phoneNumber" : "Phone Number",
    "alternatePhoneNumber" : "Alternate Phone Number (optional)",
    "city": "City",
    "state" : "State",
    "address" : "Address",
    "addressLineN" : "Address line {n}",
    "landMark" : "Landmark {optionalText}",
    "expiresOn" : "Expires on: {expiryDate}",
    "deliveryText" : "{deliveryTextMsg} on",
    "slot" : "{currentSlotStartDate} - {currentSlotEndDate}",
    "giftWrapped" : "This is gift wrapped.",
    "pending" : "Pending",
    "unSubscribeStatus" : "Unsubscribe{clickedStatus}",
    "subscribeStatus" : "Subscribe{clickedStatus}",
    "termsAndConditions" : "Terms and Conditions",
    "selectAnAdd" : "Please select an address!",
    "orderCannotDelivered" : "Sorry. This product cannot be delivered at this address.",
    "alertMsg": "{length} new alert(s) to view in this order.",
    "errorBankList": "Error while getting List of Banks",
    "errorStateList": "Error while getting List of States",
    "errorCityList": "Error while getting List of Cities",
    "errorBranchList": "Error while getting List of Branches",
    "selectBank": "Select Bank",
    "selectState": "Select State",
    "selectCity": "Select City",
    "selectBranch": "Select Branch",
    "addNewAccount": "{char} Add a New Bank Account",
    "selectRefundOption": "Select Refund Options",
    "seeMore" : "See More",
    "soldBy" : "Sold by {sellerName}",
    "seller" : "Seller: {sellerName}",
    "offer" : "{offerCount} OFFER{pluralString}",
    "orderNotDeliveredReqAgain" : "Your order could not be delivered. Please click here to request delivery again.",
    "giftTo" : "Gift To{colon}",
    "giftFrom" : "Gift From{colon}",
    "message" : "Message{colon}",
    "days" : "{diff} Days",
    "leftToReach" : "left to reach you",
    "trackingID" : "Tracking Id {star}",
    "emailId" : "Email ID {star}",
    "trackYourShipment" : "Track your shipment",
    "shipmentDelivered" : "Shipment is delivered",
    "shipmentNotDelivered" : "Shipment is not delivered",
    "deliveredToNameRel" : "Delivered to {name} ( {relation} )",
    "deliveredToNameRel2" : "Delivered to {relation} ( {name} )",
    "curLocationMessage" : "Current Location: {message}",
    "curLocationNameCity" : "Current Location: {displayName}, {city}",
    "shipmentStatus" : "Shipment status",
    "shipmentSummary" : "Shipment summary",
    "totalAmount" : "Total Amount",
    "total" : "Total",
    "remainingAmount":  "Remaining Payable Amount",
    "prepaidPrice": "Pre-book Amount Paid",
    "weight" : "Weight",
    "shipper" : "Shipper",
    "rupeeSymbol" : "₹",
    "rupeeSymbolWithAmt" : "₹ {amount}",
    "kgsWithWeight" : "{weight} kgs",
    "trackingDetails" : "Tracking Details",
    "validEmailTrackID" : "Make sure you enter a valid Tracking ID and Email ID.",
    "ekartTrackID" : "You can enter only ekart logistics Tracking ID.",
    "contactCustomerCare" : "In case you need any further assistance you can contact our customer care.",
    "viewDeliveryAdd" : "View Delivery Address",
    "verifyMobileNumDeliveryAdd" : "Verify your mobile number to view the delivery address.",
    "verifyMobileNum" : "Verify your mobile number",
    "manageWhoAccess" : "Manage who can access",
    "orderAlsoTrackBy" : "This order is also tracked by {name} ({number})",
    "plusNMore" : "+ {length} more",
    "orderDetailsSharedWith" : "Order details shared with",
    "sharedPremissionRevoked" : "Shared permission revoked.",
    "sharedPremissionNotRevoked" : "Sorry, shared permission could not be revoked.",
    "shareOrderDetails" : "Send Order Details",
    "sendOrder" : "Send order details to someone",
    "send" : "Send",
    "shareOrderDetailsMsg" : "A new address was used! If this order is for someone else, you can now share the order details with that person.",
    "orderDetails" : "Order Details",
    "shareTrack" : "Share tracking with someone",
    "inValidName" : "Enter valid name",
    "inValidPhoneNum" : "Enter valid 10 digit phone number",
    "requiredPhoneNum" : "Phone number is required",
    "orderSharedSuccess" : "Order details shared successfully.",
    "orderNotShared" : "Sorry, the order could not be shared.",
    "recipientCanTrack" : "The recipient will be able to track the items in this order.",
    "otpExpires" : "OTP expires in {min} : {sec} mins",
    "enter10DigitNum" : "enter a 10-digit phone number",
    "otpSharedViaSMS" : "OTP shared successfully via SMS.",
    "couldNotGenOTP" : "We could not generate OTP",
    "notSubmitOTP" : "We could not submit OTP",
    "otpVerification" : "OTP Verification",
    "1TimePassSentOn" : "One Time Password has been sent on",
    "enter6DigitOTP" : "enter a valid 6 digit otp",
    "didntReceiveCode" : "Didn’t receive the code?",
    "resendOTP" : "Resend OTP",
    "confirm" : "Confirm",
    "verify" : "Verify",
    "dismiss" : "Dismiss",
    "youCanDoMuchMore" : "You can now do much more!",
    "track" : "Track",
    "return" : "Return",
    "detailsWithYou" : "details with you",
    "viewOrderDetails" : "View Order Details",
    "welcomeUser" : "Hi {userName}",
    "hasSharedOrder" : " has shared order",
    "scheduleDeliveryDate" : "{startTime} - {endTime}",
    "deliveryPrefSaved" : "Your delivery preferences have been saved.",
    "scheduleDelivery" : "Schedule Delivery",
    "scheduleDeliveryInstallation" : "Schedule Delivery & Installation",
    "confirmDelivery" : "Confirm Delivery",
    "deliveryCantChange": "Delivery date can't be changed",
    "installationCantChange": "Installation date can't be changed",
    "alreadyReceivedConfirmation" : "We have already received the confirmation of your delivery",
    "requestReturn" : "Request Return",
    "thingsRemember" : "Things to remember",
    "thingsRememberMsg" : "We hope you understand that we can only accept items which has not been used/ damaged along with the original accessories and packaging.",
    "whatsNext" : "What’s next?",
    "pickUpExpectedOn" : "Pick up expected on",
    "pickUpMsg" : "Pick up will happen along with the delivery",
    "returnRequestPlaced" : "Return Request Placed",
    "enter4DigitInvoiceNum" : "Enter the last 4 digits of the invoice number",
    "returnIDWithID" : "Return ID - {returnID}",
    "current" : "Current",
    "pickUp" : "Pick Up {colon}",
    "detailsItemCardStatus" : "{length} offer{pluralString}",
    "quantityWithSize" : "Quantity : {size}",
    "prexoValueOf" : "{exchangeTitle} of {title}",
    "prexoReassessNote" : "Note: ",
    "prexoSave": "Save",
    "prexoVariantsInfo" : "The prices shown are for {savedVariants}.",
    "prexoAvailableVariants" : "Select different {availableIds}",
    "prexoSelectVariant": "Select Variant",
    "prexoSelectVariantErr": "Please select {variantTilte}",
    "extendedWarPolicyNo" : "Your Extended Warranty Policy No {policyNumber}",
    "expectedBy" : "Expected by {date}",
    "expectedByNew" : "Expected by {date}, 9PM",
    "revisedPrice": "Revised Price",
    "promisedPrice": "Promised Price",
    "listPrice" : "List price",
    "sellingPrice" : "Selling price",
    "coinSaving" : "Savings Using SuperCoins",
    "knowMore" : "Know more",
    "paymentMode" : "Payment mode{pluralString}",
    "specialPrice" : "Special Price",
    "extraDiscount" : "Extra Discount",
    "paymentModeStatus" : "Payment mode : {status}",
    "payAmount" : "PAY {amount}",
    "pleaseTryLater" : "Please try after some time.",
    "otpPayText" : "OTP for delivery",
    "payTotal": "Pay {payableAmount}",
    "amountAlreadyPaid" : "Amount is already paid",
    "orderCancelInProgress" : "Order cancel request in progress",
    "courierNotProcess" : "Delivery partner is not able to process this request",
    "resendGiftCard" : "Resend Gift Card",
    "cancellationYourServiceConfirmed" : "Cancellation of your service has been confirmed.",
    "cancellationYourServiceSure" : "This will cancel your installation service for this product. Are you sure?",
    "completedOn" : "Completed on",
    "deliveryTextStatus" : "{status} on",
    "byVendor" : "By {vendor}",
    "installStatus" : "Installation within few hours of delivery",
    "notificationSubscription" : "Notification Subscription",
    "notificationSubscriptionConfirm" : "Confirm that you would like to receive updates on the following channels:",
    "stopReceivingUpdates" : "Are you sure you want to stop receiving updates?",
    "outForDelivery" : "Out for delivery",
    "schedule" : "Schedule",
    "cancelled" : "Cancelled",
    "returned" : "Returned",
    "priceDetails" : "Price Details",
    "heavyTrafficMsg" : "We are unable to load your orders due to heavy traffic. Please try again after some time",
    "orderIDWithID" : "Order ID - {orderId}",
    "refundIDWithID" : "Refund ID - {refundId}",
    "orderOnHold" : "Order on hold",
    "exchangedItems" : "Exchanged Items",
    "attachedProduct" : "Attached Product",
    "shippingDetails" : "Shipping Details",
    "services" : "Services",
    "otherItemsInOrder" : "Other Items In This Order",
    "deliveryPersonFeNum" : "You can reach the delivery person at {feNumber}",
    "pinExt" : "PIN: {ext}",
    "call" : "Call",
    "activationCode" : "Activation Code",
    "shareMorePeople" : "{plus} Send order details to more people",
    "basketItemsSingular" : "Kilos Basket {length} item",
    "hyperlocalItemsSingular" : "Minutes Basket {length} item",
    "basketItemsPlural" : "Kilos Basket {length} items",
    "hyperlocalItemsPlural" : "Minutes Basket {length} items",
    "shipmentTitle": "Shipment {shipmentIndex}",
    "unShippedTitle": "Items not shipped",
    "shipmentItemsSingular": "({length} item)",
    "shipmentItemsPlural": "({length} items)",
    "returnItemActions" : "RETURN {all}{basket}",
    "addWallet" : "ADD TO WALLET",
    "yesCancel" : "Yes, Cancel",
    "cancelReturn" : "CANCEL RETURN",
    "ODcancelReturn" : "Cancel return",
    "cancelBasket" : "Cancel Basket",
    "copy" : "Copy",
    "newIssue" : "New issue",
    "oldIssue" : "Old issue",
    "deliveryAttemptedAgain" : "Delivery will be attempted again",
    "deliveryDaysLeftToDeliver" : "Delivery in {daysLeftToDeliver} {pluralString}",
    "deliveryBTMFromTo" : "Delivery between {fromDate} and {toDate}",
    "deliveryByDate" : "Delivery by {toDate}",
    "delivered" : "Delivered",
    "userNotLoggedIn" : "Please log in to rate this product.",
    "editReview" : "Edit Review",
    "refundStatus" : "Refund status",
    "refundTnCTemplate": "By tapping on “Submit Request” I agree to <link>terms and conditions</link> of refunds.",
    "resumFixYourProblem" : "Try resuming where you left the steps to fix your problem.",
    "resume" : "RESUME",
    "clipboardCopied" : "Copied to clipboard.",
    "ok" : "Ok",
    "myOrder" : "My Orders",
    "prexoItemStatus" : "{pinIcon} Note: Your old {verticalTextMappedValue} will be examined before confirming the {exchangeTitle} during delivery.",
    "youDoNotHaveOrder" : "Looks like you do not have any orders.",
    "startShopping" : "Start Shopping",
    "noMoreOrders" : "No more orders",
    "editCurrentAddress" : "Edit current address",
    "area" : "Area",
    "refresh" : "Refresh",
    "helpUsDeliver" : "Help Us Deliver",
    "scheduleDeliveryIns" : "Schedule your Delivery and Installation",
    "prexoAbtStatus1" : "About the {title}",
    "prexoStatus" : "Your old {value} will be examined before confirming the {parentVertical}",
    "note" : "Note",
    "prexoAbtStatus2" : "If your old {value} does not qualify for pickup, you can still get your new {parentVertical} by paying",
    "via" : "via {mode}",
    "supportThankYou" : "Thank you for your support",
    "orderPlaced" : "Order Placed",
    "celebCoins": "SuperCoins on the way",
    "celebSavings": "Saved, Yay!",
    "totalPrzItems" : "Total price for {numberOfItems} item{pluralString}",
    "coin" : "SuperCoin{pluralString} Cashback",
    "convenientDateTime" : "Choose a convenient date and time for delivery of large appliances",
    "bewareMSG1" : "{alertIcon} Beware of fraudulent calls & messages!",
    "bewareMSG2" : "We don’t ask for bank OTP/pin for offers or demand money",
    "readMore" : "Read more",
    "happyFlipkart" : "Are you happy with the Flipkart Experience?",
    "orderEmailMsg" : "Your order has been placed successfully and is being processed. We will send you the confirmation e-mail in a short while",
    "orderPlacedMsg" : "Order placed successfully",
    "confirmationEmail" : "We will send you the confirmation email shortly",
    "no" : "No",
    "yes" : "Yes",
    "prexoItemStatus2" : "Your old {vertical} will be completely checked during delivery before confirming the {exchangeTitle}. ",
    "prexoItemStatus3" : "If it does not qualify for the {exchangeTitle}, you can pay {paymentOnDelivery} and get your new {originalItemVertical}.",
    "imeiWithNum" : "IMEI {imeiNumber}",
    "updatesSubscribed" : "Subscribed to Updates",
    "UpdatesSubscribe" : "Subscribe to Updates",
    "close" : "Close",
    "preferenceSaved" : "Your preference has been updated",
    "somethingWentWrong" : "Something went wrong",
    "nextSteps" : "Next steps",
    "orderdOn" : "Ordered on",
    "items" : "Items",
    "initiated!": "Initiated!",
    "grandTotal" : "Grand Total",
    "selectReason" : "Please choose a reason.",
    "selectSubReason" : "Please add more details.",
    "enterComment" : "Please enter a comment.",
    "len10KLess" : "Comments should have a maximum character limit of 1000.",
    "validPickUpDeliveryAdd" : "Please select a valid pickup/delivery address.",
    "returnOption" : "Please select a return option.",
    "selectNewItem": "Please choose a new item.",
    "selectRefundMode" : "Please choose a refund mode.",
    "selectAnAccount" : "Please choose an account.",
    "selectUpiId": "Please choose a UPI ID.",
    "almostThere" : "Almost There",
    "clickAllowToEnable" : "Please click on 'Allow' to enable Push notifications",
    "subTotal" : "Subtotal",
    "cancellationPolicy" : "CANCELLATION POLICY",
    "cancelStatus" : "These products have been purchased on a combo offer or have been packaged/shipped together or order value is falling below minimum threshold. Cancelling this item will result in the cancellation of the following",
    "cancelItemStatus" : "{linkCancel} item{pluralString}",
    "too" : "too",
    "cancellationConfirmed" : "Cancellation Confirmed",
    "itemDispatched" : "Item dispatched",
    "checkStatus" : "Check Status",
    "keepShopping" : "Keep Shopping",
    "viewAllOrders" : "View All Orders",
    "instantRefundStatus" : "Instant refund after we receive the item(s)",
    "amountWithdrawnBankAccount" : "Amount can be withdrawn to your bank account from My Account section",
    "new" : "New",
    "refundAmount" : "Refund Amount",
    "requestCancellation" : "Request Cancellation",
    "cancellationReason" : "Reason For Cancellation {suffix}",
    "chooseReasonForCancellation" : "Please choose for cancellation",
    "claimMoney" : "Claim Money",
    "refundMode" : "Refund Mode",
    "termsOfUse" : "terms of use",
    "phonePeAgree": "By confirming the cancel, you agree to the PhonePe",
    "orderNotCancelable" : "Cancellation is not possible for this Order.",
    "commentsOptional" : "Comments (optional)",
    "cancelProduct" : "Cancel Product",
    "continueShopping" : "Continue Shopping",
    "addNewAddress" : "Add New Address",
    "accMismatchMsg" : "There’s a mismatch in the account numbers. Please check and retry.",
    "generalTextMsg" : "{text} {amount}",
    "withdraw" : "Withdraw",
    "withdrawToBankAcc" : "Withdraw to Bank Account?",
    "amountRs" : "Amount (Rs.)",
    "accountNumber" : "Account Number",
    "confirmAccountNumber" : "Confirm Account Number",
    "accountHolderName" : "Account Holder Name",
    "term1" : "By adding a new account, you hereby accept Flipkart's ",
    "term2" : "As per RBI guidelines, there are certain restrictions on transactions done using the flipkart money.",
    "accountWithNum" : "Account {num}",
    "transactionLimits" : "Transaction Limits",
    "perTransaction" : "Per transaction",
    "withdrawlsLimit" : "In single day you make up to 4 withdrawls.",
    "daily" : "Daily",
    "monthly" : "Monthly",
    "yearly" : "Yearly",
    "accountAddedSuccessfully" : "Successfully added account",
    "bankPassbook" : "Refer to your Bank Passbook for these details",
    "addNewBankAccount" : "Add New Account",
    "addNewUpiId" : "Add a New UPI ID",
    "addAccount" : "Add Account?",
    "ifscLookIp" : "IFSC look up",
    "color" : "Color",
    "size" : "Size",
    "sizeWithColon" : "Size:",
    "policy" : "policy",
    "confirmItemsConditionReturn" : "Please confirm that the following items in the given condition is available for return",
    "validPhoneNumber" : "Enter a valid phone number",
    "scheduleACall" : "Schedule A Call",
    "resolveQuickly" : "Let us help you resolve the matter quickly.",
    "slotSelect" : "Select A Slot",
    "exchangeOptions" : "Exchange Options",
    "selectSize" : "Please select a size",
    "pickUpDelivery" : "Pick up and delivery",
    "existingAccount" : "Existing account",
    "existingUpiId": "Existing UPI ID",
    "enterUpiId": "Enter your UPI ID",
    "upiPoweredBy": "Powered by {source}",
    "upiNotFound": "UPI ID not found. Please try again.",
    "whatDoReturn" : "What do you want in return?",
    "iAgree" : "I Agree",
    "returnOptions" : "Return Options",
    "returnActionMsg" : "You will need to ship the product yourself. A maximum of Rs 250 will be refunded towards the shipping cost if the delivery partner's bill is shared. Please check the return request related email for detailed instructions.",
    "shipmentReturn" : "Return the shipment to",
    "returnActionMsg2" : "We hope you understand that we can only accept items for return, if they have not been used or damaged.",
    "returnActionMsg3" : "The brand's original packaging (if present), MRP tags/labels and accessories also need to be returned along with the item. Please ensure any personal data (in Electronics products) is erased.",
    "returnActionMsg4" : "Your return request will be processed only after our delivery partner confirms delivery. If you have already received the item, you too can confirm delivery and process your return.",
    "viewOrders" : "View Orders",
    "waitingDeliveryConfirmation" : "Waiting for Delivery Confirmation.",
    "approved" : "Approved",
    "awaitingApproval" : "Awaiting Approval",
    "pickUpDeliveryMsg" : "Pick up will happen along with the delivery.",
    "pickUpBy" : "Pick up will happen by",
    "yourReturnID" : "Your return id is",
    "callTime" : "Call time",
    "callBackNow" : "Call back now",
    "callBackTime": "Call back with in {time}",
    "returnRequested" : "Return Requested",
    "requested" : "Requested",
    "reasonForReturn" : "Reason for return",
    "moreDetails" : "More details",
    "comments" : "Comments",
    "shareFurtherInfo" : "Please share further information.",
    "goToOrderDetails" : "Go to order details",
    "done" : "Done",
    "myOrders" : "My Orders",
    "referenceID" : "Reference Id: {externalId}",
    "accountDetails" : "Account details",
    "findIFSC" : "Find IFSC",
    "previousAccounts" : "Previous accounts",
    "refundProcessedMsg" : "We have received your account details. Your refund will be processed in 5-7 days.",
    "refundInitiated" : "Refund is initiated.",
    "selectDiffProd" : "Please select a different product",
    "cod" : "COD",
    "confirmCancellation" : "Confirm Cancellation",
    "ifscCode" : "IFSC Code",
    "rescheduleCallBackMsg" : "Do you want us to call on another number?",
    "confirmReturn" : "Submit Request",
    "replacementSentByDate" : "Replacement will be sent by {date}",
    "guideStepsTitle" : "{title} - Steps {index} of {length}",
    "basket" : "Basket",
    "all" : "All",
    "old" : "OLD",
    "noSavedAddress" : "No saved addresses",
    "pleaseCheckAddress" : "please check the address",
    "shippingDiscount" : "Shipping Discount",
    "shippingFee" : "Shipping Fee",
    "showDetails" : "Show Details",
    "newAddress" : "New Address",
    "lookUp" : "Look Up?",
    "loading" : "Loading...",
    "cntChngDefMsg": "Delivery address can't be changed",
    "addressType" : "Address Type",
    "deliveryTypeWithType" : "Delivery type: {type}",
    "status" : "Status",
    "important" : "Important",
    "accountNumMismatch" : "Account numbers mismatch. Please check and retry.",
    "searchIFSCCode" : "Search for your IFSC code",
    "bankName" : "Bank Name",
    "branchName" : "Branch Name",
    "readAllCheck" : "Read All Checks",
    "viewChecks" : "View Checks",
    "checkOldDevice" : "Checks on your old {device}",
    "prexoChecklist" : "Important things for exchange",
    "amtShouldMoreThan" : "Amount should be more than",
    "amtCannotMoreThan" : "Amount cannot be more than",
    "returnBasket" : "Return {all} {basket}",
    "stillNoOrders" : "Still no orders?",
    "amountReceivable": "Amount Receivable",
    "noOrders" : "You have no orders",
    "pushNotifications" : "Push Notifications",
    "enableNotificationsMsg" : "Enable notifications to stay updated with your order",
    "notNow" : "NOT NOW",
    "okay" : "OKAY",
    "wasThisHelpful" : "Was this helpful?",
    "replacement" : "Replacement",
    "exchange" : "Exchange",
    "tryDeliveryAgain" : "Try delivery again",
    "editAddress" : "Edit",
    "titleDetails" : "{title} details",
    "resultForString" : "Results for '{string}'",
    "addAcc" : "ADD ACCOUNT",
    "createBankAcc" : "Create Bank Account?",
    "skip" : "SKIP",
    "new1" : "new",
    "claimMsg1" : "For claim related queries, give us a call on our helpline",
    "claimPolicyNum" : "Policy Number : {policyNum}",
    "validTill" : "Valid Till {date}",
    "haveQuestions" : "Have questions {suffix}",
    "readOurFAQs" : "Read our FAQs",
    "claimMsg2" : "about complete mobile protection plan.",
    "claimMsg3" : "Activated on {title} ",
    "claimMsg4" : "Activated on: {date}",
    "deviceNum" : "with device number: {deviceID}",
    "claimTerms" : "View Terms & Conditions",
    "helpSearchPlaceHolder": "Search for topics or questions",
    "yourIssues" : "Your issues",
    "recentIssues": "Recent issues with this order",
    "seeAllIssues" : "See All Issues",
    "attachments" : "Attachments:",
    "prevMsgs" : "+{numberOfMsgs} previous messages",
    "yourIssuesWithThisItem" : "Your Issues With This Item",
    "incidentUpdate" : "{unseenThreadCount} Update Received",
    "incidentUpdatePlural" : "{unseenThreadCount} Updates Received",
    "viewAllIssues" : "View All Issues",
    "howCanWeHelpYou": "How can we help you?",
    "addImage" : "Add Images/PDF",
    "explainYourIssue" : "Please explain your issue",
    "issuesRaised" : "You raised {incidentCount} issue with this order",
    "issuesRaisedPlural": "You raised {incidentCount} issues with this order",
    "download" : "Download",
    "hours" : "{time} hour",
    "hoursPlural": "{time} hours",
    "minutes" : "{time} minute",
    "minutesPlural": "{time} minutes",
    "plusItems" : "+{count} items",
    "writeToUs" : "Write To Us",
    "bnplTitle": "Your Flipkart Pay Later bill",
    "bnplSubTitle": "Pay by {dueDate} to avoid late fee.",
    "bnplButton": "Pay {billAmount}",
    "cncCancelRefund": "{coinCount} SuperCoin will be refunded to your account",
    "cncCancelRefundPlural": "{coinCount} SuperCoins will be refunded to your account",
    "fkTravel": "Travel Bookings",
    "fkPartnerApps": "Super Partner Apps",
    "chngAddNumber": "Change or Add number",
    "altPhnErr": "Please use another phone number",
    "cantTakeAction": "can't be changed",
    "chngePhnMsg": "Delivery communications will be sent to these numbers",
    "uploadItemImage" : "Upload item image",
    "seeInstructions" : "See Instructions",
    "returnRequests" : "Return Requests",
    "viewAllReturnRequests" : "View all Return Requests",
    "proceedToImageUpload" : "Proceed to Image Upload",
    "instructionTakingPhoto" : "Instructions for taking photo",
    "anItem" : "an Item",
    "imageUploadFail" : "Upload failed",
    "imageUploadSuccess": "Uploaded successfully",
    "trackReturn": "Track Return",
    "Ordered": "Order Confirmed",
    "OrderedAndApproved": "Ordered and Approved",
    "Packed": "Packed",
    "Shipped": "Shipped",
    "Delivery": "Delivery",
    "Delivered": "Delivered",
    "Return": "Return",
    "cancelRequested": "Cancel Requested",
    "Cancelled": "Cancelled",
    "returnApproval": "Return Approval",
    "returnApproved": "Return Approved",
    "returnRejected": "Return Rejected",
    "Pickup": "Pickup",
    "Refund": "Refund",
    "TechnicianVisit": "Technician Visit",
    "Uninstallation": "Uninstallation",
    "Replacement": "Replacement",
    "Exchange": "Exchange",
    "CallWithExecutive": "Call With Executive",
    "ReturnCancelled": "Return Cancelled",
    "ReturnCompleted": "Return Completed",
    "ChatWithSeller": "Chat With Seller",
    "PickupAndReplace": "Pickup and Replace",
    "PickupAndExchange": "Pickup and Exchange",
    "ReturnCancellationRequested": "Return Cancellation Requested",
    "DeliveryFailed": "Delivery Failed",
    "Troubleshooting": "Troubleshooting",
    "DeliveryConfirmation": "Delivery Confirmation",
    "OrderPending": "Order Pending",
    "createAccount": "Create Account",
    "iFSClookup": "IFSC look up",
    "termsandConditions": "Terms and Conditions",
    "accountdetails": "Account details",
    "flipkartSupport": "Flipkart Support",
    "editaddress": "Edit address",
    "requestaReturn": "Request a Return",
    "selectRefundOptions": "Select Refund Options",
    "helpwithOtherIssues": "Help with Other Issues",
    "frequentlyAskedQuestions": "Frequently Asked Questions",
    "helpwithOrder": "Help with Order",
    "trackyourissue": "Track your issue",
    "emailus": "Email us",
    "submitissue": "Submit issue",
    "requestaCall": "Request a Call",
    "yourissues": "Your issues",
    "imageVerification": "Image Verification",
    "couponApplied": "{number} coupon{s}",
    "and": " & ",
    "boughtFor": "Bought for ",
    "titleSurvey": "Awesome!",
    "subtitleSurvey": "That’s all for now.",
    "errorFillingName": "Please enter only alphabets.",
    "save": "Save",
    "continue": "Continue",
    "installationDetails": "Installation Details",
    "confirmDeliveryText": "Confirm Delivery & Installation Time",
    "installation": "Installation",
    "preordered": "Preordered",
    "paymentdue": "Payment Due",
    "paymentPending": "Payment pending",
    "paymentSuccess": "Payment successful",
    "billInProgress": "Bill settlement in progress",
    "billSettled": "Bill settled",
    "billFailed": "Bill settlement failed",
    "rechargeInProgress": "Recharge in progress",
    "rechargeProcessed": "Recharge processed",
    "rechargeFailed": "Recharge failed",
    "paymentWindowClosed": "Payment Window Closed",
    "standardFitting":"This price is based on standard fittings. ",
    "installationviewDetails":"View Details",
    "changeDeliveryTime":"Change Delivery Time",
    "changeInstallationTime": "Change Installation Time",
    "serviceJeeves":"{title} from {vendor} Expert",
    "chatNetworkDisrupted": "Connection Lost. Check the internet connection and try refreshing the page.",
    "chatNetowrkConnecting": "Problem reaching our servers. Retrying…",
    "chatNetworkReconnected": "And we are back!",
    "chatInactive": "This chat is no longer active. For any further queries visit our Help Centre / 24X7 Customer Care",
    "chatAgain": "Chat Again",
    "myChats": "My Chats",
    "typeMessage": "Type a Message...",
    "copyLink": "Copy Link",
    "downloadAttachment": "Download attachment?",
    "copyLinkMsg": "Copy the link below and paste in a web browser to download the attachment.",
    "linkCopied": "Link copied to clipboard",
    "noChat": "No Chats Found",
    "noActiveConv": "You have no active conversations",
    "share": "Share",
    "orderNotPlaced": "Order Not Placed",
    "paymentConfirmed": "Payment Confirmed",
    "confirmOrder": "Confirm Order",
    "morePreorder": "{len} more pre-booked item in this order",
    "morePreorders": "{len} more pre-booked items in this order",
    "completePreorder": "Complete payment in {time}",
    "preorderWindow": "Payment window opens at {day}",
    "okayGotIt": "Okay, got it",
    "amountPayable": "Amount payable",
    "preorderItem": "Pre-booked item",
    "itemPreordered": "Item Pre-booked",
    "recoTitle": "You might be also interested in",
    "orderETA": "Your order is",
    "etaMinsAway": "{remainingETA} minutes away",
    "orderDeliveredBy": "Your order will be delivered by",
    "sharedBy": "Shared by {buyer}",
    "rateNow": "Rate this product now",
    "gstDetails": "GST Details",
    "accept&cont": "Accept & Continue",
    "groupedCancel": "{count} items in this order were packed together. We will be unable to deliver if any item is cancelled in the order.",
    "getGftCrd": "Get Gift Card",
    "pdpClaim": "Price Drop Claims",
    "rfndVia": "Claim price drop via:",
    "qty": "Qty",
    "otherItemsSingular":"1 more item will be cancelled",
    "otherItemsPlural":"{itemsCount} more items will be cancelled",
    "plsNote": "Please Note",
    "cnclCndtn": "Cancellation conditions",
    "cancelFeeWaived": "Cancellation Fee has been waived off",
    "cancelFeeCharged": "Cancellation Fee of ₹{amount} applicable",
    "cancelFee": "Cancellation Fee",
    "cancelFeeClaimLoading": "Processing request...",
    "cancelFeeClaimConfirm": "Claim ₹{amount}",
    "cancelFeeClaimSuccess": "Cancellation Fee waived off",
    "endOfSearch": "End of search results",
    "filters": "Filters",
    "apply": "Apply",
    "srchPlchldr": "Search your order here",
    "gftCrd": "Gift Card",
    "obdOcTitle": "Open Box Delivery for {itemsCount} item",
    "obdOcTitles": "Open Box Delivery for {itemsCount} items",
    "obdOdTitle": "Open Box Delivery for this item",
    "obdOtpTitle": "Verify Open Box Delivery",
    "clrFltr": "Clear Filter",
    "details": "Details",
    "seeDetails": "See details",
    "why": "Why?",
    "offerInapplicable": "Offer Removed",
    "changeInPrice": "Change in price for other items",
    "viewSmartPackDetails": "Manage SmartPack",
    "reply": "Reply",
    "replyToIssue": "Leave your message here",
    "partner" : "Partner: {sellerName}",
    "bookASlot": "Book a slot",
    "g2OD": "Go to Order Details",
    "tryAgain": "Try Again",
    "pboViewOffers": "View All Offers",
    "pboAvailableOffers": "Available Offers",
    "pboExpired": "Please refresh the page and try again.",
    "viewItemDetails": "View Item Details",
    "basketValue": "Total Basket Value",
    "viewBasketDetailsSingular": "View Basket Details ({length} item)",
    "viewBasketDetailsPlural": "View Basket Details ({length} items)",
    "phWPin": "Phone no: {ph} (Pin: {pin})",
    "couponCode": "Coupon code",
    "claimBefore": "claim before {date}",
    "free": "Free",
    "returnSurvery":'Select item to give feedback for',
    "uploadProof": "Upload Proof",
    "orderReceived": "Order Received",
    "superCoinSaving":"Save up to ₹100 extra on ",
    "superCoinSavingSubtext":"your next order",
    "updateFlipkartApp":"Update Flipkart app",
    "versionDescription":"You are using an older version of the Flipkart app which no longer supports the Help option",
    "versionDescriptionSubtext":"Please update to the latest version or open this page in browser",
    "openInBrowser":"Open in Browser",
    "updateApp":"Update App",
    "verificationRequired": "Verification Required",
    "autoCaptureText": "Trying to Auto Capture",
    "verificationDetails": "OTP verification is required to proceed. We will send the OTP on your mobile number registered with Flipkart.",
    "proceed": "Proceed",
    "resendOtp": "Resend OTP",
    "noOtp": "Didn't get the OTP?",
    "MOQMessage":"There's a minimum order quantity for this item. If you cancel any one, all units of this item will be cancelled.",
    "cashbackModeSelectionHeader": 'Choose your payment mode',
    "selectPayoutMode": 'Select payment mode',
    "payoutModeAddedSuccessfully": 'Successfully updated',
    "returnRestart": "We seemed to have faced an issue processing your request. Please resubmit your request so that we can try again.",
    "includesApplicablefees": 'Includes refund of applicable fees',
    "issueWithOrder": 'Issue with Order',
    "seeAllUpdates":'See All Updates',
    "addressChangeFailed": "Address Change Failed",
    "notDeliverable": "Not deliverable",
    "ad": 'Ad',
    "addBankAccountError": "Bank account validation unsuccessful. Please check your account details and try again later.",
    "tagloopWarning": "Returns/Exchanges are not accepted if the seal tag is lost or broken.",
    "happyAttachSuccessSubtitle": "We're sorry about this. Sit back and relax, we'll take it from here.",
    "happyAttachSuccessTitle": "A technician will be at your doorstep within 48 hours",
    "happyAttachErrorSubtitle": "Sorry, we are unable to process your request at the moment",
    "happyAttachErrorTitle": "Please try again after sometime"
};
